<template>
  <div>
    <BTabs class="content-tabs" @activate-tab="onTabActive">
      <BTab title="Vaults">
        <Vaults ref="0" :type="type" />
      </BTab>
      <BTab title="Folders">
        <Folders ref="1" :type="type" />
      </BTab>
      <BTab title="Documents">
        <Documents ref="2" :type="type" />
      </BTab>
      <BTab v-if="type === 'user'" title="Permissions">
        <Permissions ref="3`" />
      </BTab>
    </BTabs>
  </div>
</template>

<script>
import Vaults from '@/components/content/Vaults'
import Folders from '@/components/content/Folders'
import Documents from '@/components/content/Documents'
import { mapActions } from 'vuex'
import Permissions from '@/components/content/permission/Permissions'

export default {
  name: 'Content',
  components: { Permissions, Documents, Folders, Vaults },
  props: {
    type: {
      type: String,
      default: 'organisation'
    }
  },
  data() {
    return {
      keywords: null
    }
  },
  methods: {
    ...mapActions('content', ['setTabIndex']),
    async onTabActive(...args) {
      const [newTabIndex] = args
      this.setTabIndex(newTabIndex)
      this.$emit('update:tabIndex', newTabIndex)
      if (this.type !== 'user') {
        // await this.$refs[`${newTabIndex}`].search()
        await this.$refs[`${newTabIndex}`].search(true)
      }
    }
  }
}
</script>

<style scoped>
.content-tabs {
  height: calc(100vh - 280px);
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
}
</style>
